function extractProductHandle(url) {
                    if (!url) return '';
                    let cleanUrl = url.endsWith('/') ? url.slice(0, -1) : url;
                    const segments = cleanUrl.split('/');
                    return segments[segments.length - 1];
                }
function updateURLSearchanize(collection){
    // 1. Get the current URL
    const url = new URL(window.location.href);
    const params = url.searchParams;

    // 2. Remove all parameters that contain "rb_collections"
    // We use Array.from to create a list of keys so we don't 
    // mutate the object while iterating over it.
    Array.from(params.keys()).forEach(key => {
    if (key.includes('rb_collections')) {
        params.delete(key);
    }
    });

    // 3. Add or Change the 'collection' parameter
    params.set('collection', collection);

    // 4. Change 'collection' ONLY if it already exists
    if (params.has('page')) {
        params.set('page', 1);
    }

    // 5. Update the browser address bar without a page reload
    window.history.replaceState({}, '', url);
    window.location.href = url.toString();
}
function formatMoney(basePrice) {
    var formatString = window.ShopifyCurrency || { rate: 1, format: "${{amount}}" };
    var convertedPrice = parseFloat(basePrice) * formatString.rate;
    var value = convertedPrice.toFixed(2);
    var valueNoDecimals = Math.round(convertedPrice);
    return formatString.format.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, valueNoDecimals).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ',')).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, valueNoDecimals.toString().replace('.', ','));
} 
document.addEventListener('Searchanise.Loaded', function () {
    (function ($) {
        $("body").on("click", ".searchanize_menu_item", function(){
            console.log($(this).data("url"));
            updateURLSearchanize($(this).data("url"));
        }); 
        $("body").on("click", ".snize_sidebar_li .icon-dropdown", function(e){
            //$(this).toggleClass("is-clicked");
            const $element = $(this).parent();

            // If it has the class, toggle the dropdown
            if ($element.hasClass('is-clicked')) {
                $element.removeClass('is-clicked');
                $element.find('> .dropdown-category-list').stop().slideUp('slow');
            }else{
                $element.addClass('is-clicked');
                $element.find('> .dropdown-category-list').stop().slideDown('slow');
            }

            // Handle clicked state for parent navigation
            if ($element.hasClass("is-clicked")) {
                //$element.closest(".navPages-item").addClass("is-clicked");
                //$element.parent().stop().slideDown("slow");
            }
        });
        $("body").on("click", "#snize-product-filters-title", function(e){
            e.preventDefault();
            $list = $(this).parent().find("> .all-categories-list");
            if ($(this).hasClass('open')) {
                $(this).removeClass('open')
                $(this).attr('aria-expanded', false);
                $list.stop().slideUp('slow');
            }else{
                $(this).addClass('open')
                $(this).attr('aria-expanded', true);
                $list.stop().slideDown('slow');
            }

        });
        $(document).on('Searchanise.AutocompleteUpdated', function (event, input, container) {
            console.log("qyuickSearch");
            $('.snize-product', container).each(function () {
                let $productCard = $(this);
                let productData = $productCard.data('snize_item_data');
                console.log($productCard);                
                console.log(productData);
                var minOrder = productData.metafield_ba7cc67ef754155ee21af439adc4bac0 || 1000;
                var delivery_days = productData.metafield_e996af021d3957de252b44dc10c991a4 || 50;
                const productHandle = extractProductHandle(productData.link);
                var colorsHTML = '<div class="stocka-color-picker allColor"><img src="https://cdn.shopify.com/s/files/1/0857/3213/1122/files/color-wheel_1.png?v=1756385027" width="12px" height="12px" alt="Color Picker" class="stocka-color-picker-icon"></div>';
                if( productData.metafield_bc139503d084dd3e50686a842eae6086 != undefined && productData.metafield_bc139503d084dd3e50686a842eae6086 != ""){
                    colorsHTML = '<div class="card-colors">';
                    const colors = productData.metafield_bc139503d084dd3e50686a842eae6086.split(',');
                    colors.forEach(color => {
                        const trimmedColor = color.trim(); // Clean up any accidental spaces
                        colorsHTML += `
                            <label class="color" style="background-color: ${trimmedColor}">
                                <span class="text">${trimmedColor}</span>
                            </label>`;
                    });
                    colorsHTML += '</div>';
                }
                console.log(minOrder);
                console.log(delivery_days);
                $productCard.find('.snize-title').after(`
                            <span class="min-order">${window.ShopifyTranslations.min_order} ${minOrder} ${window.ShopifyTranslations.pieces}</span>
                            <span class="delivery-details">
                                <span class="delivery-details-para">${window.ShopifyTranslations.estimate_delivery} </span>
                                <span class="pro-card-date" data-days="${delivery_days}"></span>
                            </span>
                            <a href="/en/products/gorgeous-gift-box-1#judgeme_product_reviews" class="newlyAddedCode">
                                <div class='judgeme-reviews jdgm-widget jdgm-preview-badge' data-id='${productData.product_id}' data-auto-install='false'><div style='display:none' class='jdgm-prev-badge' data-average-rating='0.00' data-number-of-reviews='0' data-number-of-questions='0'> <span class='jdgm-prev-badge__stars' data-score='0.00' tabindex='0' aria-label='0.00 stars' role='button'> <span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span> </span> <span class='jdgm-prev-badge__text'> No reviews </span> </div></div>
                            </a>
                            ${colorsHTML}
                        `
                    );
                $start_price = parseFloat(productData.metafield_1c6bb76df7b4b830229b94d9968be1eb);
                $end_price   = parseFloat(productData.metafield_26cd90e686cbbd088fb0c31539ee0ba8);
                var $price   = "&nbsp;";
                if( !isNaN($start_price) && !isNaN($end_price)){
                    var formattedStart = formatMoney($start_price);
                    var formattedEnd = formatMoney($end_price);
                    $price = formattedStart + " - " + formattedEnd;
                }
                var formattedStart = formatMoney($start_price);
                var formattedEnd = formatMoney($end_price);
                $productCard.find(".snize-price").html( $price );
                const design_online = window.ShopifyTranslations.design_online
                $productCard.find('.snize-view-link').after(`
                            <button type="button" class="product-form__submit button button--primary an- collection-design-btn" id="product-add-to-cart-${productData.product_id}" data-product-id="${productData.product_id}" data-handle="${productHandle}" data-scope="test">
                                <img src="https://cdn.shopify.com/s/files/1/0857/3213/1122/files/design.png?v=1734114845" width="" height="" class="btn-img">${design_online}
                            </button>
                    `
                );
            });
        });
        $(document).on('Searchanise.ResultsUpdated', function (event, container) {
            $('.snize-product', container).each(function () {
                let $productCard = $(this);
                let productData = $productCard.data('snize_item_data');
                console.log($productCard);                
                console.log(productData);
                if($productCard.hasClass("stock_product_card")){
                    return false;
                }
                const productHandle = extractProductHandle(productData.link);

                var colorsHTML = '<div class="stocka-color-picker allColor"><img src="https://cdn.shopify.com/s/files/1/0857/3213/1122/files/color-wheel_1.png?v=1756385027" width="12px" height="12px" alt="Color Picker" class="stocka-color-picker-icon"></div>';
                if( productData.metafield_bc139503d084dd3e50686a842eae6086 != undefined && productData.metafield_bc139503d084dd3e50686a842eae6086 != ""){
                    colorsHTML = '<div class="card-colors">';
                    const colors = productData.metafield_bc139503d084dd3e50686a842eae6086.split(',');
                    colors.forEach(color => {
                        const trimmedColor = color.trim(); // Clean up any accidental spaces
                        colorsHTML += `
                            <label class="color" style="background-color: ${trimmedColor}">
                                <span class="text">${trimmedColor}</span>
                            </label>`;
                    });
                    colorsHTML += '</div>';
                }
                $productCard.addClass("stock_product_card");
                $productCard.attr("id", `collection-product-details-${productData.product_id}`);
                var minOrder = productData.metafield_ba7cc67ef754155ee21af439adc4bac0 || 1000;
                var delivery_days = productData.metafield_e996af021d3957de252b44dc10c991a4 || 50;
                $productCard.find('.snize-title').after(`
                        <span class="min-order">${window.ShopifyTranslations.min_order} ${minOrder} ${window.ShopifyTranslations.pieces}</span>
                        <span class="delivery-details">
                            <span class="delivery-details-para">${window.ShopifyTranslations.estimate_delivery} </span>
                            <span class="pro-card-date" data-days="${delivery_days}"></span>
                        </span>
                        <a href="/en/products/gorgeous-gift-box-1#judgeme_product_reviews" class="newlyAddedCode">
                            <div class='judgeme-reviews jdgm-widget jdgm-preview-badge' data-id='${productData.product_id}' data-auto-install='false'><div style='display:none' class='jdgm-prev-badge' data-average-rating='0.00' data-number-of-reviews='0' data-number-of-questions='0'> <span class='jdgm-prev-badge__stars' data-score='0.00' tabindex='0' aria-label='0.00 stars' role='button'> <span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span> </span> <span class='jdgm-prev-badge__text'> No reviews </span> </div></div>
                        </a>
                        ${colorsHTML}
                    `
                );
                $start_price = parseFloat(productData.metafield_1c6bb76df7b4b830229b94d9968be1eb);
                $end_price   = parseFloat(productData.metafield_26cd90e686cbbd088fb0c31539ee0ba8);
                var $price   = "&nbsp;";
                if( !isNaN($start_price) && !isNaN($end_price)){
                    var formattedStart = formatMoney($start_price);
                    var formattedEnd = formatMoney($end_price);
                    $price = formattedStart + " - " + formattedEnd;
                }
                var formattedStart = formatMoney($start_price);
                var formattedEnd = formatMoney($end_price);
                $productCard.find(".snize-price").html( $price );
                const design_online = window.ShopifyTranslations.design_online
                $productCard.find('.snize-view-link').after(`
                            <button type="button" class="product-form__submit button button--primary an- collection-design-btn" id="product-add-to-cart-${productData.product_id}" data-product-id="${productData.product_id}" data-handle="${productHandle}" data-scope="test">
                                <img src="https://cdn.shopify.com/s/files/1/0857/3213/1122/files/design.png?v=1734114845" width="" height="" class="btn-img">${design_online}
                            </button>
                    `
                );

                

                

            });
            $("#snize_filters_block_collections").remove();
            $(".snize-filters-sidebar #searchanizeTrendingProductsI").remove();
            const content = $('#searchanizeCollections').html();
            const contentTrending = $('#searchanizeTrendingProducts').html();
            $(".snize-filters-sidebar.snize-product-filters").append(content).append(contentTrending);        
        });
        $("body #snize_results").addClass("cacat");
    })(window.Searchanise.$);
});
//ADD GRID BUTTONS
const STORAGE_KEY = 'snize_grid_columns';
const GRID_SELECTOR = '#snize-search-results-grid-mode';
const TOGGLE_SELECTOR = '.searchanizeToggleColumns';
function applyColumnClass(className) {
    var $grid = $(GRID_SELECTOR);

    // Find all possible column classes from the buttons to ensure we clean up correctly
    var allPossibleClasses = $(TOGGLE_SELECTOR).map(function() {
        return $(this).data('col');
    }).get().join(' ');

    // Remove old classes and add the new one
    $grid.removeClass(allPossibleClasses).addClass(className);

    var $buttons = $(TOGGLE_SELECTOR);
    $buttons.removeClass("active");    
    $buttons.filter(function() {
        return $(this).data('col') == className;
    }).addClass("active");

    // Save to local storage
    localStorage.setItem(STORAGE_KEY, className);
}
$(document).on('click', TOGGLE_SELECTOR, function(e) {
    e.preventDefault();
    $(TOGGLE_SELECTOR).removeClass("active")
     $(this).addClass("active");
    var colClass = $(this).data('col');
    applyColumnClass(colClass);
});

$(document).on('Searchanise.ResultsUpdated', function(event, container) {
    console.log("TESTTTTTTTT");
    $("body #snize_results").addClass("pisat");
    $("#sortBySearchanize").remove();
    $(".snize-main-panel-dropdown").prepend(`
            <span id="sortBySearchanize">${window.ShopifyTranslations.sort_by}</span>
         `
    );
    $("#snize_results .snize-horizontal-left").empty().append(`
                                                                <div class="toolbar"><div class="toolbar-col toolbar-colLeft">
                                                                    <label class="toolbar-label">${window.ShopifyTranslations.view_as}</label>
                                                                    <div class="toolbar-item toolbar-viewAs clearfix" data-view-as="">
                                                                        <span class="toolbar-icon icon-mode icon-mode-grid grid-3 searchanizeToggleColumns" data-col="snize-three-columns" role="button" aria-label="Grid 3" tabindex="0"></span>
                                                                        <span class="toolbar-icon icon-mode icon-mode-grid grid-4 searchanizeToggleColumns" data-col="snize-four-columns" role="button" aria-label="Grid 4" tabindex="0"></span>
                                                                        <span class="toolbar-icon icon-mode icon-mode-grid grid-5 searchanizeToggleColumns" data-col="snize-five-columns" role="button" aria-label="Grid 5" tabindex="0"></span>
                                                                    </div>
                                                                </div></div>
                                                            `
                                                        );
    var savedClass = localStorage.getItem(STORAGE_KEY);
    if (savedClass) {
        applyColumnClass(savedClass);
    }
    //SET 0.1 price filter steps
    var inputs = document.querySelectorAll('.snize-price-range-input');
      
      inputs.forEach(function(input) {
        // Setting step to "0.1" allows typing 10.5, 10.2, etc.
        // Use "0.01" if you need cents (10.99).
        input.setAttribute('step', '0.1'); 
      });

});